export enum VoiceContactStatus {
  RINGING = 'ringing',
  INCOMING = 'incoming',
  ACTIVE = 'active',
  DISCONNECTED = 'disconnected',
  HOLD = 'hold',
  HOLDING = 'holding',
  JOINED = 'joined',
  DIALING = 'dialing',
  MASKING = 'masking',
  INQUEUE = 'Inqueue',
  TRANSFER = 'transfer',
  RESOLVED = 'resolved',
}
